import { useMediaQuery } from "react-responsive";

export const ResponsiveDeviceType = (): number => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isTablet = useMediaQuery({ minWidth: 769, maxWidth: 1024 });
  const isDesktop = useMediaQuery({ minWidth: 1025 });

  let type: number = 3;
  if (isMobile && !isTablet && !isDesktop) {
    type = 1;
  } else if (!isMobile && isTablet && !isDesktop) {
    type = 2;
  } else if (!isMobile && !isTablet && isDesktop) {
    type = 3;
  }
  return type;
};
